export default "__VITE_ASSET__DXm8m11q__"